"use client";

import { usePathname } from "next/navigation";
import TopNav from "@/components/TopNav";

/** Hides the global TopNav on routes that have their own full-screen navigation (e.g. /staff). */
export default function ConditionalTopNav() {
    const pathname = usePathname();
    // Hide on routes that have their own full-screen navigation
    if (pathname?.startsWith("/staff")) return null;
    if (pathname?.startsWith("/candidate-hub")) return null;
    if (pathname?.startsWith("/dashboard")) return null;
    // Group detail pages render inside the dashboard shell (own sidebar)
    if (/^\/groups\/[^/]+\/[^/]+\/?$/.test(pathname || "")) return null;
    // Group meeting phases (e.g. /contribute) render inside GroupMeetingShell
    if (/^\/groups\/[^/]+\/[^/]+\/meetings\//.test(pathname || "")) return null;
    // Volunteer profile pages render inside the dashboard shell (own sidebar)
    if (/^\/volunteers\/[^/]+\/?$/.test(pathname || "")) return null;
    return <TopNav />;
}
